import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { vehicleServices } from "../services/AllServices";

export const getVehicleData = createAsyncThunk(
  "vehicles/getVehicleData",
  async (value) => {
    const { data } = await vehicleServices.getAllVehicles(value);
    return data.response;
  }
);

export const getVehicleById = createAsyncThunk("getVehicleById", async (value) => {
  const { data } = await vehicleServices.getVehicleById(value);
  return data.response;
});

export const getVehicleCategories = createAsyncThunk("getVehicleCategories", async () => {
  const { data } = await vehicleServices.getVehicleCategories();
  return data.response;
});

export const getVehicleStats = createAsyncThunk("getVehicleStats", async () => {
  const { data } = await vehicleServices.getVehicleStats();
  return data.response;
});

const initialState = {
  vehicles: [],
  currentPage: 0,
  totalPages: 0,
  totalRecords: 0,
  vehicle: {},
  categories: [],
  stats: {},
};

const updateVehicles = (state, { payload }) => {
  state.vehicles = payload.data;
  state.totalPages = payload.totalPages;
  state.totalRecords = payload.totalRecords;
  state.currentPage = payload.currentPage;
};

const selectedVehicle = (state, { payload }) => {
  state.vehicle = payload;
};

const updateCategories = (state, { payload }) => {
  state.categories = payload;
};

const updateStats = (state, { payload }) => {
  state.stats = payload;
};

export const vehicleSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    getAllVehicles: (state, { payload }) => {
      state.vehicles = payload;
    },
    getVehicles: (state, { payload }) => {
      state.vehicles = payload;
    },
    deleteVehicle: (state, { payload }) => {
      state.vehicles = state.vehicles.filter((vehicle) => vehicle._id !== payload);
    },
    changeStatus: (state, { payload }) => {
      const { id, status } = payload;
      const vehicleIndex = state.vehicles.findIndex((vehicle) => vehicle._id === id);

      if (vehicleIndex !== -1) {
        const updatedVehicles = [...state.vehicles];
        updatedVehicles[vehicleIndex] = {
          ...updatedVehicles[vehicleIndex],
          status,
        };

        return {
          ...state,
          vehicles: updatedVehicles,
        };
      }

      return state;
    },
    editVehicle: (state, action) => {
      // Handle vehicle edit logic if needed
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleData.fulfilled, updateVehicles)
      .addCase(getVehicleById.fulfilled, selectedVehicle)
      .addCase(getVehicleCategories.fulfilled, updateCategories)
      .addCase(getVehicleStats.fulfilled, updateStats);
  },
});

export const { getAllVehicles, getVehicles, deleteVehicle, editVehicle, changeStatus } =
  vehicleSlice.actions;

export default vehicleSlice.reducer;


